import { render, staticRenderFns } from "./TdConversionAttributeUpdateMeasurementState.vue?vue&type=template&id=da365432&scoped=true"
import script from "./TdConversionAttributeUpdateMeasurementState.vue?vue&type=script&lang=ts"
export * from "./TdConversionAttributeUpdateMeasurementState.vue?vue&type=script&lang=ts"
import style0 from "./TdConversionAttributeUpdateMeasurementState.vue?vue&type=style&index=0&id=da365432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da365432",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/td-conversion-attribute-change-measurement-state.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2FTdConversionAttributeUpdateMeasurementState.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports